import styled from 'styled-components';

export const Wrapper = styled.div`
  .form-actions {
    margin-top: 30px;

    & > * {
      margin-right: 20px;
    }
  }
  .input-billing {
    height: 85%;
  }

  .filter-item {
    max-height: 40px;
    width: 140px;
  }
`;
